import { useCallback, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import List from "../grid.component";
import { Alert, Button, message, Modal, Tooltip } from "antd";
import { isErrorMessage } from "../shared/error.message";
import apiCalls from "src/api/apiCalls";
import RoleAddEdit from "./roleForm";
import ActionsComponent from "../shared/ActionsComponent";
const RolesGrid = () => {
    const navigate = useNavigate();
    const gridRef = useRef(null);
    const [checkboxSelection, setCheckboxSelection] = useState([]);
    const [checkBoxData, setCheckBoxData] = useState({})
    const [errorMessage, setErrorMessage] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteMessage, setDeleteMessage] = useState(null)
    const [buttonLoader, setButtonLoader] = useState(false)
    const [formModal, setFormModal] = useState(false)
    const [mode, setMode] = useState(null)
    const [isRefresh, setIsRefresh] = useState(false)
    const handleCheckboxChanges = useCallback(
        (prop, e) => {
            setErrorMessage(null);
            if (e.target.checked) {
                const rowChecked = prop.dataItem;
                let _selection = [...checkboxSelection];
                let idx = _selection.indexOf(rowChecked.id);
                if (checkboxSelection) {
                    _selection = [];
                }
                if (idx > -1) {
                    _selection.splice(idx, 1);
                } else {
                    _selection.push(rowChecked.id);
                }
                setCheckBoxData(rowChecked);
                setCheckboxSelection(_selection);
            } else {
                setCheckBoxData({});
                setCheckboxSelection([]);
            }
        }, [checkboxSelection]);
    const handleToolBarActions = (action) => {
        if (!checkBoxData.id && action !== 'add') {
            setErrorMessage("Please select one record!")
            return;
        }
        switch (action) {
            case 'add':
                setFormModal(true)
                setCheckBoxData({})
                setMode("Add")
                setErrorMessage(null);
                break;
            case 'edit':
                setFormModal(true)
                setErrorMessage(null);
                setMode("Edit")
                break;
            case 'managepermission':
                navigate(`/settings/roles/managePermissions/${checkBoxData.id}/${checkBoxData?.name}`)
                break;
            case 'delete':
                setDeleteModal(true)
                setErrorMessage(null);
                setDeleteMessage(null)
                break;
            default:
                return;
        }
    }
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    const deleteRole = useCallback(async () => {
        try {
            setButtonLoader(true);
            const response = await apiCalls.deleteRoleSave(checkBoxData.id);
            if (response.ok) {
                setDeleteModal(false);
                setDeleteMessage(null);
                setCheckBoxData({});
                message.success({
                    content: "Role Deleted Successfully.",
                    className: "custom-msg",
                    duration: 3,
                });
                gridRef?.current?.refreshGrid();
                setIsRefresh(true)
            } else {
                setDeleteMessage(isErrorMessage(response?.data));
            }
        } catch (error) {
            setDeleteMessage(error);
        } finally {
            setButtonLoader(false);
        }
    }, [checkBoxData, apiCalls, gridRef]);
    const handleDeleteModal = useCallback(() => {
        setDeleteModal(false)
        setCheckBoxData({})
    }, [])
    const handleFormModal = useCallback(() => {
        setFormModal(false)
        setCheckBoxData({})
        setErrorMessage(null)
    }, [])
    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
    }, [handleToolBarActions])
    const closeDeleteError = useCallback(() => {
        setDeleteMessage(null)
    }, [])
    const refreshCallBack = useCallback(() => {
        setIsRefresh(false);
    }, [])
    return (
        <>
            <div className=''>
                <div className='flex justify-end items-center gap-2 mb-3'>
                    <ActionsComponent serviceName={"CardsManageService.Settings"} onActionClick={onActionClick} targetTabName="Roles" />
                </div>
                {errorMessage &&
                    <div className='mb-4'>
                        <Alert
                            className='mb-4'
                            type="error"
                            description={errorMessage}
                            onClose={closeError}
                            showIcon
                            closable
                        />
                    </div>
                }
                <List
                    url={process.env.REACT_APP_GATEWAYS + `api/identity/roles`}
                    pSize={10}
                    className="custom-grid"
                    ref={gridRef}
                    screenName={'Settings_Roles'}
                    handleSelection={handleCheckboxChanges}
                    showGridSelection={true}
                    selection={[checkBoxData?.id]}
                    refreshCallBack={refreshCallBack}
                    refresh={isRefresh}
                />
            </div>
            <Modal
                open={deleteModal}
                onCancel={handleDeleteModal}
                title={'Confirm Delete'}
                maskClosable={false}
                closeIcon={
                    <Tooltip title="Close">
                        <span className="icon close c-pointer" />
                    </Tooltip>
                }
                footer={<><div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                    <Button
                        type="primary"
                        className="cancel-btn"
                        onClick={handleDeleteModal}
                    >
                        Close
                    </Button>
                    <Button onClick={deleteRole} className='primary-btn' type="primary" loading={buttonLoader}>Confirm</Button></div> </>
                }>
                {deleteMessage !== null && (
                    <Alert
                        className=''
                        type="error"
                        description={deleteMessage}
                        onClose={closeDeleteError}
                        showIcon
                        closable
                    />
                )}
                <div className='text-light-valueColor text-sm mb-3 p-3.5'><span>Do you really want to Delete?</span></div>
            </Modal>
            {formModal && <RoleAddEdit isModal={formModal} closeModal={handleFormModal} mode={mode} id={checkBoxData.id} gridRef={gridRef} setIsRefresh={setIsRefresh} />}
        </>
    )
}
export default RolesGrid